<template>
  <section>
    <h2>Affichage obligatoire</h2>
    <div
      class="d-flex align-items-center justify-content-start my-4 row no-gutters"
    >
      <!-- Reglement Intérieur -->
      <div
        class="col-3 col-sm-2 order-1 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalReglement = !modalReglement"
          type="button"
          class="btn btn-primary btn_repertoire"
        >
          <font-awesome-icon icon="book" size="2x" />
        </button>
        <span class="text-primary span_repertoire text-wrap">Réglement</span>
        <b-modal
          v-model="modalReglement"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Réglement intérieur"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/1-%20REGLEMENT%20INTERIEUR.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Egalite  -->
      <div
        class="col-3 col-sm-2 order-2 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalEgalites = !modalEgalites"
          type="button"
          class="btn btn-success btn_repertoire"
        >
          <font-awesome-icon icon="user" size="2x" />
        </button>
        <span class="text-success span_repertoire text-wrap">Egalité</span>
        <b-modal
          v-model="modalEgalites"
          centered
          hide-footer
          scrollable
          title="Egalité"
        >
          <ul class="list-group">
            <li class="list-group-item text-center">
              <span
                @click="
                  modalEgaliteProfessionnelle = !modalEgaliteProfessionnelle
                "
                >Professionnelle</span
              >
            </li>
            <b-modal
              v-model="modalEgaliteProfessionnelle"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Egalité Professionnelle"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/2-%20%20Egalit%c3%a9%20Professionnelle.pdf&embedded=true"
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalEgaliteSalariale = !modalEgaliteSalariale"
                >Rémunération</span
              >
            </li>

            <b-modal
              v-model="modalEgaliteSalariale"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Egalité Rémunération"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/5%20-%20Egalit%c3%a9%20R%c3%a9mun%c3%a9ration.pdf&embedded=true"
              ></iframe>
            </b-modal>
          </ul>
        </b-modal>
      </div>

      <!-- Discrimination -->

      <div
        class="col-3 col-sm-2 order-3 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          type="button"
          class="btn btn-secondary btn_repertoire"
          @click="modalDiscrimination = !modalDiscrimination"
        >
          <font-awesome-icon icon="door-open" size="2x" />
        </button>
        <span class="text-secondary span_repertoire text-wrap"
          >Discrimination</span
        >
        <b-modal
          v-model="modalDiscrimination"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Discrimination"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/3-%20Discrimination.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Représentant du personel -->
      <div
        class="col-3 col-sm-2 order-4 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalRp = !modalRp"
          type="button"
          class="btn btn-dark btn_repertoire"
        >
          <font-awesome-icon icon="handshake" size="2x" />
        </button>
        <span class="text-dark span_repertoire text-wrap">Représentant</span>
        <b-modal
          v-model="modalRp"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Représentant du personnel"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/4-%20Liste%20Repr%c3%a9sentants%20du%20Personnel.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Horaire de travail -->
      <div
        class="col-3 col-sm-2 order-10 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          type="button"
          class="btn btn-info btn_repertoire"
          @click="modalHoraire = !modalHoraire"
        >
          <font-awesome-icon icon="clock" size="2x" />
        </button>
        <span class="text-info span_repertoire text-wrap"
          >Horaire de travail</span
        >
        <b-modal
          v-model="modalHoraire"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Horaire Travail"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/10-%20Horaires%20de%20travail%20Cergy.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Interdiction de fumer  -->

      <div
        class="col-3 col-sm-2 order-8 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalInterdiction = !modalInterdiction"
          type="button"
          class="btn btn-danger btn_repertoire"
        >
          <font-awesome-icon icon="smoking-ban" size="2x" />
        </button>
        <span class="text-danger span_repertoire text-wrap">Interdiction</span>
        <b-modal
          v-model="modalInterdiction"
          size="xl"
          centered
          hide-footer
          scrollable
          content-class="modalSize"
          title="Interdiction"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/8%20-%20Interdiction%20de%20fumer%20et%20de%20vapoter.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Sauveteur Secouriste -->
      <div
        class="col-3 col-sm-2 order-11 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          @click="modalSauveteur = !modalSauveteur"
          type="button"
          class="btn btn-info btn_repertoire"
        >
          <font-awesome-icon icon="medkit" size="2x" />
        </button>
        <span class="text-info span_repertoire text-wrap">Sauveteur</span>
        <b-modal
          v-model="modalSauveteur"
          centered
          hide-footer
          scrollable
          title="Sauveteur"
        >
          <ul class="list-group">
            <li class="list-group-item text-center">
              <span
                @click="
                  modalSauveteurBatA12bureau = !modalSauveteurBatA12bureau
                "
                >Bâtiment A12 bureau</span
              >
            </li>
            <b-modal
              v-model="modalSauveteurBatA12bureau"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Sauveteur Batiment A12 bureau"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/11-a%20SST%20-%20A12%20-%20BUREAU.pdf&embedded=true"
              ></iframe>
            </b-modal>

            <li class="list-group-item text-center">
              <span @click="modalSauveteurBatA12 = !modalSauveteurBatA12"
                >Bâtiment A12</span
              >
            </li>

            <b-modal
              v-model="modalSauveteurBatA12"
              size="xl"
              centered
              hide-footer
              scrollable
              content-class="modalSize"
              title="Bâtiment A12"
            >
              <iframe
                class="modalPdf"
                src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/11-b%20SST%20-%20A12.pdf&embedded=true"
              ></iframe>
            </b-modal>
          </ul>
        </b-modal>
      </div>

      <!-- Harcelement -->
      <div
        class="col-3 col-sm-2 order-6 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          type="button"
          class="btn btn-dark btn_repertoire"
          @click="modalHarcelement = !modalHarcelement"
        >
          <font-awesome-icon icon="user-alt-slash" size="2x" />
        </button>
        <span class="text-dark span_repertoire text-wrap">Harcèlement</span>
        <b-modal
          v-model="modalHarcelement"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Harcèlement"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/6-%20%20Harc%c3%a8lement.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- Vidéo Surveillance -->

      <div
        class="col-3 col-sm-2 order-7 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          type="button"
          class="btn btn-primary btn_repertoire"
          @click="modalSurveillance = !modalSurveillance"
        >
          <font-awesome-icon icon="video" size="2x" />
        </button>
        <span class="text-primary span_repertoire text-wrap">Surveillance</span>
        <b-modal
          v-model="modalSurveillance"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Vidéosurveillance"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/7-%20%20Vid%c3%a9osurveillance.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>

      <!-- SI -->

      <div
        class="col-3 col-sm-2 order-9 d-flex flex-column justify-content-around align-items-center my-3"
      >
        <button
          type="button"
          class="btn btn-primary btn_repertoire"
          @click="modalSI = !modalSI"
        >
          <font-awesome-icon icon="server" size="2x" />
        </button>
        <span class="text-primary span_repertoire text-wrap"
          >Charte d'utilisation SI</span
        >
        <b-modal
          v-model="modalSI"
          size="xl"
          centered
          hide-footer
          scrollable
          title="Charte d'utilisation SI"
          content-class="modalSize"
        >
          <iframe
            class="modalPdf"
            src="https://docs.google.com/viewer?url=https://dev.amorce.org/cboyer/Doc_demo.kisdis.com/AFFICHAGE%20OBLIGATOIRE/9-%20%20Charte%20d'utilisation%20SI.pdf&embedded=true"
          ></iframe>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      modalReglement: false,
      modalEgalites: false,
      modalEgaliteProfessionnelle: false,
      modalEgaliteSalariale: false,
      modalRp: false,
      modalInterdiction: false,
      modalSauveteur: false,
      modalSauveteurBatA12bureau: false,
      modalSauveteurBatA12: false,
      modalDiscrimination: false,
      modalHoraire: false,
      modalHarcelement: false,
      modalSurveillance: false,
      modalSI: false
    };
  }
};
</script>
